module.exports = "/wp-content/themes/conversion/public/dist//svgs/icon-chevron-minus.svg";